<ion-app dir="{{textDir}}">
  <!-- when=false means that the split pane will never expand automatically -->
  <!-- For more info check https://ionicframework.com/docs/api/split-pane -->
    <ion-router-outlet id="menu-content"></ion-router-outlet>
</ion-app>
